<app-nav (emitLang)="reciever($event)" [lang]="languageCode"></app-nav>
<router-outlet (activate)="onActive()" />
<app-footer />
